<div class="container">
  <div class="header">
    <div class="titulo">
      Programas Eleitorais
    </div>
    <div class="turno">
      2º TURNO
    </div>
    <div class="img-eleicoes">
      <img src="assets/img/logo-eleicoes-black.png">
    </div>
  </div>
  <div class="opcoes">
    <div class="cidades">
      <div class="form-group">
        <select class="form-control select" id="select-cidades" (change)="onSelectCidade($event.target.value)">
          <option hidden [value]="" selected>CIDADE</option>
          <option *ngFor="let c of cities" [value]="c.key">{{c.value}}</option>
        </select>
      </div>
      <div class="btn-compara">
        <label class="switch" style="margin-bottom: 0;">
          <input type="checkbox" [checked]="modeloTemplateCheckbox" (change)="changeTemplateContent($event)">
          <span class="slider round"></span>
        </label>
        <span>Comparar</span>
      </div>
    </div>
    <div class="btn-temas">
      <div class="btn-icon">
        <button type="button" id="5" class="btn btn-options btn-primary" [disabled]="btnNotSaude"
          (click)="onClickBtn('SAÚDE')">
          <svg-icon class="ico" src="assets/icon/saude.svg" [svgStyle]="{ 'width.px':28 }"></svg-icon>
        </button>
      </div>
      <div class="btn-icon">
        <button type="button" id="2" class="btn btn-options btn-primary" [disabled]="btnNotEducacao"
          (click)="onClickBtn('EDUCAÇÃO')">
          <svg-icon class="ico" src="assets/icon/educacao.svg" [svgStyle]="{ 'width.px':28}"></svg-icon>
        </button>
      </div>
      <div class="btn-icon">
        <button type="button" id="6" class="btn btn-options btn-primary" [disabled]="btnNotSeguranca"
          (click)="onClickBtn('SEGURANÇA')">
          <svg-icon class="ico" src="assets/icon/seguranca.svg" [svgStyle]="{ 'width.px':28}"></svg-icon>
        </button>
      </div>
      <div class="btn-icon">
        <button type="button" id="1" class="btn btn-options btn-primary" [disabled]="btnNotEconomia"
          (click)="onClickBtn('ECONOMIA E EMPREGO')">
          <svg-icon class="ico" src="assets/icon/economia.svg" [svgStyle]="{ 'width.px':28}"></svg-icon>
        </button>
      </div>
      <div class="btn-icon">
        <button type="button" id="3" class="btn btn-options btn-primary" [disabled]="btnNotPolitica"
          (click)="onClickBtn('POLÍTICA E CORRUPÇÃO')">
          <svg-icon class="ico" src="assets/icon/politica.svg" [svgStyle]="{ 'width.px':28}"></svg-icon>
        </button>
      </div>
      <div class="btn-icon">
        <button type="button" id="4" class="btn btn-options btn-primary" [disabled]="btnNotSocial"
          (click)="onClickBtn('POLÍTICAS SOCIAIS E DIREITOS HUMANOS')">
          <svg-icon class="ico" src="assets/icon/sociais.svg" [svgStyle]="{ 'width.px':28}"></svg-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="content" [hidden]="HiddenModeloNormal">
    <div *ngFor="let tema of temas" id="{{ tema.value + 'Tema' }}" class="inativo">
      <div class="content-titulo">
        <span>{{tema.value}}</span>
      </div>
      <div id="{{'accordion'+tema.key}}">
        <div class="card" *ngFor="let candidato of candidates">
          <div class="card-header" id="{{'heading'+candidato.id+tema.key}}">
            <div class="img-candidato">
              <img src="./assets/img/{{candidato.id}}.png">
            </div>
            <div class="dados-candidato">
              <h5 class="mb-0">
                <button class="btn btn-accordion " data-toggle="collapse"
                  [attr.data-target]="'#collapse'+candidato.id+tema.key" aria-expanded="false"
                  [attr.aria-controls]="'collapse'+candidato.id+tema.key"
                  (click)="onClickBtnCard(candidato.id.toString()+tema.key.toString())">

                  <div *ngIf="candidato.status === 'INDEFERIDO'; else elseTemplate">
                    <span class="candidato">{{ candidato.name }} - <b>INDEFERIDO</b></span><br>
                  </div>
                  <ng-template #elseTemplate>
                    <span class="candidato">{{ candidato.name }} </span><br>
                  </ng-template>

                  <span class='partido'>{{ candidato.political_party }}</span>
                  <div id="{{'icon-accordion'+candidato.id+tema.key}}" class="icon-accordion-open"></div>
                </button>
              </h5>
            </div>
          </div>

          <div id="{{'collapse'+candidato.id+tema.key}}" class="collapse"
            [attr.aria-labelledby]="'heading'+candidato.id+tema.key" [attr.data-parent]="'#accordion'+tema.key">
            <div class="card-body">
              <div [innerHTML]="candidato.candidatesThemes[tema.key -1].proposal"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content" [hidden]="HiddenModeloCompare">

    <div class="compara">
      <div *ngIf="this.temaSelecionado != 0 " class="content-titulo">
        <span>{{ this.temas[this.temaSelecionado -1].value }}</span>
      </div>

      <div class="content-candidatos">
        <div *ngFor="let candidato of candidates" class="content-candidato">
          <div class="card mb-3">
            <img src="./assets/img/{{ candidato.id }}.png" class="card-img-top" alt="nome candidato">
            <h5> {{ candidato.name }}</h5>
            <span>{{ candidato.political_party}}</span>
            <hr>
            <div class="card-body">
              <div *ngIf="this.temaSelecionado != 0" class="card-text">
                <div
                  [innerHTML]="candidato.candidatesThemes[this.temaSelecionado -1].proposal">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="loader loader-default" data-text="" [class]="{ 'is-active':isActive }"></div>

